import Swal from 'sweetalert2';

export function isPlaceholderEditing(selection) {
  const srcToCheck =
    selection.getSrc() ||
    selection._element.src ||
    selection._element.currentSrc;

  if (srcToCheck.includes('placeholder/magicframe')) {
    Swal.fire({
      icon: 'warning',
      title: 'Attenzione',
      text:
        'Prima di utilizzare gli strumenti di fotoritocco, è necessario sostituire la foto con quella del defunto.',
      confirmButtonColor: '#278e8e',
    });
    return true;
  }

  return false;
}
